import { render } from "./UploadOpportunity.vue?vue&type=template&id=6994f198&scoped=true&lang=true"
import script from "./UploadOpportunity.vue?vue&type=script&lang=js"
export * from "./UploadOpportunity.vue?vue&type=script&lang=js"

import "./UploadOpportunity.vue?vue&type=style&index=0&id=6994f198&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6994f198"

export default script